<template>
  <div class="notification">
    <div
      v-if="true"
      :class="{'has-padding': isNotificationPage && (isDesktop || isEmpty)}"
    >
      <BliTabs
        v-model="selectedTab"
        variant="scrollable"
      >
        <BliTab
          v-for="(item, idx) in tabs"
          :key="idx"
          :title="item.name"
          :value="item.value"
        />
      </BliTabs>
    </div>
    <div
      v-if="!notificationsList?.length && isLoadingNotifications"
      class="notification-loader"
    >
      <BliLoaderGeneral size="l" />
    </div>
    <div
      v-else-if="isEmpty"
      :class="['notification-empty-state', {'remove-padding': isNotificationPage}]"
    >
      <img
        src="@vue3/assets/images/invalid-link.svg"
        width="68"
        height="68"
        alt="empty"
      >
      <div class="details">
        <div class="title">
          {{ $t('notification.emptyState.title') }}
        </div>
        <div class="description">
          {{ $t('notification.emptyState.ALL') }}
        </div>
      </div>
    </div>
    <div
      v-else
      :class="['notification-list', {'has-border': isNotificationPage && isDesktop}]"
      @scroll="handleScroll"
    >
      <div
        v-for="notification in notificationsList"
        :key="notification.id"
        :class="['notification-item', {'notification-read': notification.isRead}]"
      >
        <div class="notification-item-icon">
          <component
            :is="getNotificationIcon(notification.notificationType)"
            width="15"
            height="15"
          />
        </div>
        <div
          class="notification-item-details"
          @click="handleNotificationClick(notification)"
        >
          <div class="notification-item-title">
            {{ notification.title }}
          </div>
          <div class="notification-item-description">
            {{ notification.body }}
          </div>
          <div
            v-if="notification.image"
            class="notification-item-image"
          >
            <img
              :src="notification.image"
              width="240"
              height="135"
              :alt="notification.title"
            >
          </div>
        </div>
        <div class="notification-content">
          <div
            v-if="!notification.isRead"
            class="notification-item-unread"
          >
            <div class="notification-item-unread-circle" />
          </div>
          <div
            v-if="notification.link"
            class="notification-item-redirectUrl"
          >
            <BliIconSiOpenNew
              height="16"
              width="16"
              @click.native="handleRedirectionUrl(notification.link)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="isLoadingNotifications && notificationsList?.length"
        class="notification-loading"
      >
        <BliLoaderGeneral />
      </div>
    </div>
    <BliModal
      v-if="isNotificationDetailModalVisible"
      :active="isNotificationDetailModalVisible"
      width="small"
      @blur="resetNotificationModal"
    >
      <BliModalHeader
        class="notification-title"
        @close="resetNotificationModal"
      >
        <template #title>
          {{ notificationModalContent.title }}
        </template>
      </BliModalHeader>
      <BliModalBody>
        {{ notificationModalContent.description }}
      </BliModalBody>
      <BliModalFooter
        v-if="notificationModalContent.link"
        long-action
      >
        <BliButton @click="handleRedirectionUrl(notificationModalContent.link)">
          {{ $t('notification.clickLink') }}
        </BliButton>
      </BliModalFooter>
    </BliModal>
  </div>
</template>
<script src="./index.js" />
<style scoped lang="scss">
    html:not([dark]) {
      @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
      @import './index.scss';
    }
    html[dark] {
      @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
      @import './index.scss';
    }
    @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
</style>
